

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  ArrowPathIcon,
  DocumentArrowDownIcon,
  CurrencyDollarIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/outline";
import TableComponent from "../../components/TableComponent";
import { toast } from "react-toastify";
import * as ExcelJS from "exceljs";
import CouponModal from "../../components/admin/CouponModal";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import ConfirmModal from "../../components/ConfirmModal";
import {
  deleteRegistration,
  fetchRegistration,
} from "../../features/admin/RegistrationSlice";
import ApiCustom from "../../utils/ApiCustom";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const Registration = () => {
  const dispatch = useDispatch();
  const { registrations, status, error } = useSelector(
    (state) => state.registrations
  );
  const { partners } = useSelector((state) => state.partners);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedActivityType, setSelectedActivityType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [isOpenPayment, setIsOpenPayment] = useState(false);
  const [paymentId, setPaymentId] = useState(null);
  const [statusType, setStatusType] = useState("");
  const [confirmContent, setConfirmContent] = useState("");

  const hasPermission = (requiredPermission) => {
    const userId = localStorage.getItem("userId");
    if (userId == 1) {
      return true;
    }
    const userPermissions = getUserPermissions();
    return userPermissions.includes(requiredPermission);
  };

  const getUserPermissions = () => {
    const permissions = localStorage.getItem("permissions");
    return permissions
      ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
      : [];
  };

  const handleClosePayment = () => {
    setIsOpenPayment(false);
    setPaymentId(null);
    setStatusType("");
    setConfirmContent("");
  };

  const handlePayment = () => {
    handleUpdateValue(paymentId, statusType);
    handleClosePayment();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentCoupon(null);
  };

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteRegistration(deleteId)).unwrap();
      toast.success("Xóa đăng ký thành công!");
      handleCloseDeleteModal();
    } catch (error) {
      toast.error("Đã xảy ra lỗi khi xóa đăng ký!");
    }
  };

  const exportToExcel = async () => {
    const dataToExport = selectedActivityType
      ? filteredRegistrations
      : registrations;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Danh sách đăng ký");

    worksheet.columns = [
      { header: "STT", key: "index", width: 4 },

      { header: "Đơn vị", key: "companyName", width: 30 },
      { header: "Người tham gia", key: "fullName", width: 20 },
      { header: "Hoạt động", key: "postTitle", width: 40 },
      { header: "Email", key: "email", width: 25 },
      { header: "Số điện thoại", key: "phone", width: 20 },
    ];

    const rows = dataToExport.map((item, index) => ({
      index: index + 1,
      companyName:
        partners?.find((p) => p.id === item.company?.id)?.companyName || "",
      fullName: item.fullName || "",
      postTitle: item.post?.title || "",
      email: item.email || "",
      phone: item.phoneNumber || "",
    }));

    worksheet.addRows(rows);

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };
      cell.font = {
        bold: true,
        color: { argb: "FF000000" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = {
            wrapText: true,
          };
        });
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Danh_sach_dang_ky_${selectedActivityType}.xlsx`;
    console.log(selectedActivityType, "selectedActivityType");

    a.click();
    window.URL.revokeObjectURL(url);

    // toast.success("Xuất Excel thành công!");
  };

  const handleUpdateValue = async (id, field) => {
    ApiCustom.put(`eventRegistration-change-field/${id}?t=` + field)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          toast.success("Cập nhật thành công");
          dispatch(fetchRegistration());
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.messages);
      });
  };

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchRegistration());
    }
  }, [status, dispatch]);

  useEffect(() => {
    dispatch(fetchRegistration());
  }, []);

  const activityTypes = [
    ...new Set(
      registrations?.map((reg) => reg.post?.title || "Chưa phân loại")
    ),
  ];

  const headers = [
    {
      key: "id",
      label: "STT",
      render: (item, index) => (
        <div>
          <p className="font-medium">{index + 1}</p>
        </div>
      ),
    },
    {
      key: "fullName",
      label: "Họ và tên",
      render: (item) => (
        <div>
          <p className="font-medium">{item?.fullName}</p>
        </div>
      ),
    },
    {
      key: "phoneNumber",
      label: "Số điện thoại",
      render: (item) => (
        <div>
          <p className="font-medium">{item?.phoneNumber}</p>
        </div>
      ),
    },
    {
      key: "companyName",
      label: "Đơn vị",
      render: (item) => (
        <div>
          <p className="font-medium">
            {partners?.filter((p) => p.id === item.company?.id)[0]?.companyName}
          </p>
        </div>
      ),
    },
    {
      key: "post",
      label: "Hoạt động",
      render: (item) => (
        <div>
          <p className="font-medium">{item.post ? item.post?.title : ""}</p>
        </div>
      ),
    },
    {
      key: "payment",
      label: "Phí tham gia",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.payment === "Đã đóng"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          } whitespace-nowrap`}
        >
          {item.payment}
        </span>
      ),
    },
    {
      key: "status",
      label: "Tham gia",
      render: (item) => (
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            item.status === "Có"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          } whitespace-nowrap`}
        >
          {item.status}
        </span>
      ),
    },
  ];

  if (hasPermission("REGISTER_UPDATE") || canViewAuditHistory()) {
    headers.push({ key: "setting", label: "Thao tác" });
  }

  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("REGISTER_UPDATE") && (
          <button
            disabled={item.status == "Không" || item.payment == "Đã đóng"}
            onClick={() => {
              setIsOpenPayment(true);
              setPaymentId(item.id);
              setStatusType("payment");
              setConfirmContent("Xác nhận đóng phí tham gia?");
            }}
            title="Đóng phí tham gia"
            className="btn btn-outline btn-success btn-sm px-3 my-1 rounded"
          >
            <CurrencyDollarIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("REGISTER_UPDATE") && (
          <button
            disabled={item.status == "Có"}
            onClick={() => {
              setIsOpenPayment(true);
              setPaymentId(item.id);
              setStatusType("status");
              setConfirmContent("Xác nhận có tham gia?");
            }}
            title="Tham gia"
            className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded"
          >
            <CheckCircleIcon className="w-5 h-5" />
          </button>
        )}
        <AuditHistoryButton
          module="EVENT_REGISTRATION"
          entityType="EventRegistration"
          entityId={item.id}
        />
      </div>
    ),
  };

  // Lọc danh sách đăng ký theo loại hoạt động
  const filteredRegistrations = selectedActivityType
    ? registrations
        ?.filter(
          (reg) =>
            (reg.post?.title || "Chưa phân loại") === selectedActivityType
        )
        .filter((item) =>
          searchValue === ""
            ? true
            : [item.fullName, item.phoneNumber].some((field) =>
                field?.toLowerCase().includes(searchValue.toLowerCase())
              )
        )
    : registrations?.filter((item) =>
        searchValue === ""
          ? true
          : [item.fullName, item.phoneNumber].some((field) =>
              field?.toLowerCase().includes(searchValue.toLowerCase())
            )
      );

  if (status === "loading") {
    return (
      <div className="flex justify-center items-center h-64">
        <ArrowPathIcon className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="p-4 text-red-500 bg-red-50 rounded-md">
        Đã xảy ra lỗi: {error}
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="block md:flex justify-between items-center mb-3">
        <h1 className="text-2xl font-bold">
          Quản lý đăng ký tham gia hoạt động
        </h1>
      </div>

      <div className="flex justify-end mb-6">
        <div className=" flex items-center space-x-2 mr-3">
          <label
            htmlFor="userSearchFilter"
            className="text-sm font-medium w-24"
          >
            Tìm kiếm:
          </label>
          <input
            type="search"
            className="w-full px-2 py-1 border rounded-lg focus:outline-none pr-10"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>

        <div className="block md:flex items-center  space-x-0 md:space-x-4 ">
          {/* Dropdown lọc loại hoạt động */}
          <div className="form-control w-full max-w-xs my-2 md:m-0 ">
            <select
              className="select select-bordered select-sm "
              value={selectedActivityType}
              onChange={(e) => setSelectedActivityType(e.target.value)}
            >
              <option value="">Tất cả hoạt động</option>
              {activityTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={exportToExcel}
            className="btn btn-success btn-outline btn-sm"
          >
            <DocumentArrowDownIcon className="w-5 h-5 mr-2" />
            Xuất Excel
          </button>
        </div>
      </div>

      <div className="rounded-lg shadow">
        <TableComponent
          headers={headers}
          data={filteredRegistrations}
          settings={tableSettings}
        />
      </div>

      {isModalOpen && (
        <CouponModal coupon={currentCoupon} onClose={handleCloseModal} />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />

      <ConfirmModal
        isOpen={isOpenPayment}
        onClose={handleClosePayment}
        onSubmit={handlePayment}
        message={confirmContent}
      />
    </div>
  );
};

export default Registration;



